import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Input from '../../modules/Input';
import Button from '../../modules/Button';
import InputGroup from '../../modules/InputGroup';
import FormButtonPanel from '../../modules/FormButtonPanel';
import AlertBox from '../../modules/AlertBox';
import FieldSet from '../../modules/FieldSet';
import AuthenticationMethods from "../../modules/AuthenticationMethods";

import * as formScroller from '../../../services/forms/scroller';
import AlertMessage from "../../modules/AlertMessage/index";
import FormatAlertMessage from "../../modules/FormatAlertMessage/index";

class Account extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isShowingAuthMethods : false
        };

        this._onAuthSetupSuccess = this._onAuthSetupSuccess.bind(this);
    }

    componentDidMount() {
        this.props.setInitialShowState(this.props.initialValues.mfa_active);
    }

    _onAuthSetupSuccess() {
        this.props.setAuthSetupSuccess();
        if (window.scrollTo) {
            window.scrollTo(0, 0);
        }
    }

    render() {

        const {
            submitSucceeded,
            submitFailed,
            handleSubmit,
            pristine,
            submitting,
            error,
            authSetupSuccessful
        } = this.props;

        return (
            <div>
                <AlertMessage>
                    {((submitSucceeded && pristine) || (pristine && authSetupSuccessful) || submitFailed) && (
                        <AlertBox
                            theme={( (pristine && submitSucceeded) || (pristine && authSetupSuccessful) ) ? 'success' : 'danger'}
                        >
                            {pristine && submitSucceeded && !authSetupSuccessful && 'Your settings have been saved.'}
                            {authSetupSuccessful && 'Two-Factor Authentication was setup successfully.'}
                            {submitFailed && error && (
                                <FormatAlertMessage
                                    genericMessage={'There was a problem saving your account.'}
                                    error={error}
                                />
                            )}
                        </AlertBox>
                    )}
                </AlertMessage>

                <form onSubmit={handleSubmit}>

                    <FieldSet legend="Account Details">
                        <InputGroup>
                            <Field name="first_name" component={Input} type="text" label="First Name" required="true" />
                        </InputGroup>

                        <InputGroup>
                            <Field name="last_name" component={Input} type="text" label="Last Name" required="true" />
                        </InputGroup>

                        <InputGroup>
                            <Field name="email" component={Input} type="email" label="Email" required="true" />
                        </InputGroup>

                        <InputGroup>
                            <Field name="organisation" component={Input} label="Organisation" type="text" />
                        </InputGroup>

                        <InputGroup>
                            <Field name="job_title" component={Input} label="Job Title" type="text" />
                        </InputGroup>

                        <InputGroup>
                            <Field name="telephone" component={Input} label="Telephone" type="text" />
                            {(this.props.initialValues.auth_methods.length > 0 && this.props.initialValues.auth_methods.some(method => method.method === 'sms')) && (
                                <p>You may want to change your Two-Factor Authentication SMS number.</p>
                            )}
                        </InputGroup>
                    </FieldSet>

                    <FieldSet legend="Change Password">
                        <InputGroup>
                            <Field name="password" component={Input} type="password" label="New Password" />
                        </InputGroup>

                        <InputGroup>
                            <Field name="password_confirmation" component={Input} type="password" label="Confirm New Password" />
                        </InputGroup>
                    </FieldSet>

                    <FieldSet legend="Two-Factor Authentication">
                        <p style={{marginBottom: 12}}>Two-Factor Authentication will help protect your account with an additional security step.</p>
                        <InputGroup>
                            <Field name="mfa_active" component={Input} label="Use Two-Factor Authentication" type="checkbox" onChange={ this.props.on2FAChange } />
                        </InputGroup>
                        <AuthenticationMethods
                            show={ this.props.isShowingAuthenticationMethods }
                            onSetupSuccess={this._onAuthSetupSuccess.bind(this)}
                            userAccount={this.props.initialValues}
                        />
                    </FieldSet>

                    <FormButtonPanel position="bottom">
                        <Button disabled={pristine || submitting} type="submit">Save</Button>
                    </FormButtonPanel>
                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'account',
    onSubmitSuccess: formScroller.scrollToTop,
    onSubmitFail: formScroller.scrollToFirstError
})(Account);